import { useNavigate } from "react-router-dom";

import { ROUTES } from "../common";
import { FaceRegisterStep } from "../parts/face-register-step";

export function FaceRegistrationPage() {
  const navigate = useNavigate();

  return (
    <FaceRegisterStep
      onDone={() => navigate(ROUTES.checkin, { replace: true })}
      onCancel={() => navigate(ROUTES.login, { replace: true })}
    />
  );
}
